import React, { useState } from "react";
import { Auth } from "../firebase/firebase";
import {
  Form,
  Segment,
  Grid,
  Button,
  Message,
  Header
} from "semantic-ui-react";
import { Field, reduxForm, reset } from "redux-form";
import { useDispatch } from "react-redux";
import { TextInput } from "../templates/utils/form-fields";

let ForgottenPassword = ({ handleSubmit, submitting, pristine, invalid }) => {
  const dispatch = useDispatch();
  const [message, setMessage] = useState({});

  const handleSubmitForm = values => {
    Auth.sendPasswordResetEmail(values.email)
      .then(() => {
        setMessage({
          type: "positive",
          message: `An email has been sent to ${values.email} with instructions on how to reset your password`
        });
      })
      .catch(error =>
        setMessage({
          type: "negative",
          message: "Sorry, this email address is not recognised"
        })
      );
    dispatch(reset("forgottenPasswordForm"));
  };

  return (
    <Grid centered>
      <Grid.Column computer={4} tablet={8} mobile={16}>
        <Segment className="bm-auth">
          <Form onSubmit={handleSubmit(handleSubmitForm)}>
            <Header as="h3">Forgotten password</Header>
            <Field
              type="email"
              name="email"
              placeholder="joe@bloggs.com"
              component={TextInput}
            />
            <Button
              positive
              type="submit"
              size="tiny"
              disabled={pristine || submitting || invalid}
            >
              Submit
            </Button>
            {message.type && (
              <Message className={message.type} content={message.message} />
            )}
          </Form>
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

const validate = values => {
  const testEmail = email => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const errors = {};

  if (!values.email) {
    errors.email = "Please enter your email address";
  }

  if (values.email) {
    if (!testEmail(values.email)) {
      errors.email = "Please enter a valid email address";
    }
  }

  return errors;
};

ForgottenPassword = reduxForm({
  validate,
  form: "forgottenPasswordForm"
})(ForgottenPassword);

export default ForgottenPassword;
